import React, { Component } from 'react';
import { Button, Segment, Form, Input, Grid, Message } from 'semantic-ui-react'

export class PrevSchoolDetails extends Component {
  state = {
    haveErrors: false,
    message: '',
    error: {
      prevSchoolName: false,
      prevSchoolAddress: false,
      gradeFilename: false
    },
  }

  continue = e => {
    e.preventDefault();
    if(this.handleValidation()) {
      this.setState({haveErrors: false})
      this.props.nextStep();
    } else {
      this.setState({haveErrors: true, message: 'Required fields must not be blank.'})
    }
  };

  back = e => {
    e.preventDefault();
    this.props.prevStep();
  };

  handleValidation = () => {
    let hasValidationErrors = false;
    const { values } = this.props;
    const { error } = this.state;
    if(values.prevSchoolName === '') {
      error.prevSchoolName = true;
      this.setState({
        error
      })
      hasValidationErrors = true;
    } else {
      error.prevSchoolName = false;
      this.setState({
        error
      })
    }

    if(values.prevSchoolAddress === '') {
      error.prevSchoolAddress = true;
      this.setState({
        error
      })
      hasValidationErrors = true;
    } else {
      error.prevSchoolAddress = false;
      this.setState({
        error
      })
    }

    if(values.gradeFilename === '') {
      error.gradeFilename = true;
      this.setState({
        error
      })
      hasValidationErrors = true;
    } else {
      error.gradeFilename = false;
      this.setState({
        error
      })
    }

    if (hasValidationErrors) {
      return false;
    } else {
      return true;
    }
  }

  render() {
    const { values, handleChange } = this.props;
    return (
      <Segment className='enrollment-form-segment'>
        <h1>Previous School</h1>
          {
            this.state.haveErrors &&
            <Message
              error
              content={this.state.message}
            />
          }
        <Form>
          <Form.Group widths='equal'>
            <Form.Field required error={this.state.error.prevSchoolName} control={Input} value={values.prevSchoolName} name='prevSchoolName' label='Previous School Name' placeholder='Previous School Name' onChange={handleChange}/>
            <Form.Field required error={this.state.error.prevSchoolAddress} control={Input} value={values.prevSchoolAddress} name='prevSchoolAddress' label='Previous School Address' placeholder='Previous School Address' onChange={handleChange}/>
          </Form.Group>

        </Form>

        <h1>Requirements for New Students</h1>
        <div>
          <ul>
            <li>Philippine Statistics Authority (PSA) Birth Certificate (Original or Photocopy)</li>
            <li>1 pc. 1x1 Latest ID Picture </li>
            <li>1pc. Long Brown Envelope (to be submitted on the 1st day of classes) </li>
            <li>Certificate of Good Moral Character (for Intermediate, JHS, SHS students only) </li>
            <li>JHS Certificate of Completion (Incoming Grade 11) </li>
            <li>Report Card with Learner Reference Number (SF 9) </li>
            <li>Transcript of Records (SF 10) </li>
            <li>Education Service Contracting (ESC) Certification from the Principal (ESC Grantees only) </li>
            <li>Qualified Voucher Recipient (QVR) Certificate (for Qualified SHS Voucher Applicant)  </li>
          </ul>
          <br/>
          <p>Create a ZIP file with the aforementioned requirements. Follow this format for the zip filename: "(SURNAME)-(FIRSTNAME)-(GRADELEVEL)-REQUIREMENTS.zip" <br/>
          For example: <strong>DELACRUZ-JUAN-GRADE8-REQUIREMENTS.zip</strong> </p>

        <p>You can skip the submission of other requirements except Form 137(Report Card). Please note that your application will be temporary unless the requirements are complete.
            For further questions, you can email us at enrollment@salisonline.com or message us at SALIS FB Page. </p>
          <br/>
        </div>
        <Form>
          <Form.Group widths='equal'>
            <Form.Field
              required
              error={this.state.error.gradeFilename}
              control={Input}
              type="file"
              name='gradeFilename'
              label='Previous Report Card or Form 137'
              onChange={(e) => this.props.handleUploadGradeFileChange(e.target.files[0])}
            />
            <Form.Field
              control={Input}
              type="file"
              name='requirements'
              label='Requirements'
              placeholder='Requirements'
              onChange={(e) => this.props.handleUploadFileChange(e.target.files[0])}
            />
          </Form.Group>
        </Form>

        <Grid>
          <Grid.Column width={8}>

          </Grid.Column>
          <Grid.Column width={8} textAlign='right'>
            <Button onClick={this.back}>Back</Button>
            <Button onClick={this.continue}>Continue</Button>
          </Grid.Column>
        </Grid>

      </Segment>
    );
  }
}

export default PrevSchoolDetails;
